export default "__VITE_ASSET__DmunUm5D__"